




























































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Validator, ValidationObserver, ValidationProvider } from 'vee-validate';

import Field from '@/shared/components/Field/Field.vue';
import BaseNumericField from '@/shared/components/Inputs/BaseNumericField.vue';
import CreditCardField from '../CreditCardField.vue';
import NewCreditCardForm from '../NewCreditCardForm.vue';

import { ICheckoutCartOffer } from '@/interfaces/Checkout';
import { Payment } from '@/classes/Checkout/Payment';
import { EPaymentMethod, ECardStep } from '@/helpers/enums';

import { debounce } from '@/shared/utils/Functions';

const AppModule = namespace('App');
const CheckoutModule = namespace('App/Checkout');

@Component({
  components: {
    Field,
    BaseNumericField,
    CreditCardField,
    NewCreditCardForm,
    ValidationObserver,
    ValidationProvider,
  }
})
export default class FirstCreditCardForm extends Vue {
  @Prop()
  private value!: any;

  @Prop()
  private readonly creditCardInstallments: [];

  @Prop()
  private readonly isSecondForm: boolean;

  @Prop()
  private readonly creditCardOptions: [];

  @Prop()
  private readonly mainAmount: number;

  @Prop()
  private readonly secondAmount: number;

  @Prop()
  private secondCardIsSelected: boolean;

  @Prop()
  private showNewCardForm: boolean;

  @Prop()
  private validator: Validator;

  private debouncedApplyAmount: Function = debounce(this.applyAmount, 1500);

  public $refs!: {
    observer: any,
    creditCardField: CreditCardField,
    newCreditCardForm: NewCreditCardForm,
    [x: string]: any;
  };

  private showFragmentForm: boolean = false;

  private showNewCreditCard: boolean = false;

  @AppModule.Mutation
  private setStepFormSelected: Function;

  @AppModule.State
  private isAmountLoading: boolean;

  @CheckoutModule.Mutation
  private selectAmountPaymentCard: Function;

  @CheckoutModule.Getter('selectedOfferPayment')
  private payment: Payment;

  @CheckoutModule.Getter('selectedOfferPaymentCardSelected')
  private selectedPaymentCard: any;

  @CheckoutModule.Getter('selectedOffer')
  private offer: ICheckoutCartOffer;

  private get hasCreditCard() {
    return this.creditCardOptions && this.creditCardOptions.length > 0;
  }

  private get selectedPaymentCardId() {
    return this.selectedPaymentCard && this.selectedPaymentCard.id;
  }

  async applyAmount(name: string, value: number, keep: boolean = true) {
    await this.selectAmount(this.value);
    const valid = await this.validator.validate('amount', this.value.amount);
    if (valid) {
      this.$emit('setEligibilityByAmount');
    }
  }

  private selectAmount(amount: number) {
    this.selectAmountPaymentCard({ offer_id: this.offer.id, amount });
  }

  private get stepCreditCardSelected() {
    return this.payment && this.payment.getPaymentMethod(EPaymentMethod.creditCard) && this.payment.getPaymentMethod(EPaymentMethod.creditCard).step;
  }

  private get stepSecondCreditCardSelected() {
    return this.payment && this.payment.getPaymentMethod(EPaymentMethod.creditCard) && this.payment.getPaymentMethod(EPaymentMethod.creditCard).secondStep;
  }

  private get isSecondNewCard() {
    return this.stepSecondCreditCardSelected === ECardStep.new;
  }

  private get stepActiveCreditCard() {
    return this.stepCreditCardSelected && this.stepCreditCardSelected === ECardStep.select;
  }

  private change(input: string) {
    if (input === 'amount') {
      this.validator.validate(input, (this.$refs[input] as any).$attrs.value);
    } else {
      this.validator.validate(input, (this.$refs[input] as any).value);
    }
  }

  private showNewCreditCardForm(payload: boolean) {
    if (this.isSecondForm) {
      this.payment.setPaymentMethodField(EPaymentMethod.creditCard, 'secondStep', ECardStep.new);
    } else {
      this.showNewCreditCard = payload;
      this.$emit('showBtnToReturnToRegisteredCreditCard', payload);
    }
  }

  private selectPaymentCard(payload: any) {
    this.$emit('setCreditCard', payload);
  }

  private setCardStep(cardStep: any) {
    this.setStepFormSelected(cardStep);
    this.$emit('setCardStep', cardStep);
  }

  private setPaymentCardInstallment(payload: any) {
    this.$emit('setCardInstallment', payload);
  }

  public async validateForm() {
    if (this.stepCreditCardSelected === ECardStep.select) {
      const validCreditCardField = await this.$refs.creditCardField.validateForm();
      const validAmount = await this.validator.validate('amount', this.value.amount);

      return validCreditCardField && validAmount;
    }

    const validNewForm = await this.$refs.newCreditCardForm.validateForm();
    const validAmount = await this.validator.validate('amount', this.value.amount);

    return validNewForm && validAmount;
  }

  private createValidations() {
    this.validator.attach({
      name: 'amount',
      rules: 'required|minValueAmountToPay',
    });
  }

  @Watch('isSecondForm', { immediate: true, deep: true })
  private onChangeIsSecondForm(val: any) {
    if (val) {
      this.value.amount = this.secondAmount;
    } else {
      this.value.creditCardId = this.selectedPaymentCardId;
    }
  }

  @Watch('value.creditCardId', { immediate: true })
  private onChangeCreditCardId(val: any) {
    this.showFragmentForm = Boolean(val);
  }

  @Watch('value', { immediate: true, deep: true })
  private onChangeValue(val: any) {
    this.$emit('input', val);
  }

  mounted() {
    !this.hasCreditCard && this.showNewCreditCardForm(true);
    this.createValidations();
  }
}
